import { ReduxContext } from '@bees-web/core/types'
import * as trackableActions from './constants/trackableActions'
import interactiveMap from './interactive-map'
import reducer from './reducers'

const reduxContext: ReduxContext = {
  state: {
    reducer,
    persist: (version: number) => ({
      key: `new-web-react-home-${version}`,
      blacklist: ['banners', 'faq', 'ratings', 'ratingService'],
    }),
  },
  actions: {
    interactiveMap,
    trackables: Object.values(trackableActions),
    public: {},
  },
}

export default reduxContext
